import { API } from "aws-amplify";
import { useEffect, useState } from "react";
import { useUserSubscriptionsQuery } from "_shared/graphql";

function LastUpdated() {
  const [signalsDate, setSignalsDate] = useState("");

  const { data: subscriptionsData } = useUserSubscriptionsQuery();

  // derived from user subscriptions
  const planInterval =
    subscriptionsData?.subscriptions?.find(
      (sub) => sub.subscribed && sub.id.endsWith("plan"),
    )?.subscribed?.frequency ?? "";

  useEffect(() => {
    const checkLastUpdated = async () => {
      try {
        const data = await API.post("auth", "/cognito/checkLastUpdated", {});
        setSignalsDate(data.signalsDate);
      } catch (err) {
        console.log(err);
      }
    };
    checkLastUpdated();
  });

  return (
    <>
      <div
        className="last-updated"
        style={{
          color: "darkgrey",
        }}
      >
        {signalsDate ? `Signals and Range last updated on ${signalsDate}` : ""}
      </div>
      <div
        data-tip={
          planInterval === "intraday"
            ? `This is the closing price from the last trading day. If you are licensed for Intraday, pricing will update periodically on the hour daily.`
            : // : "Your update period is set to Daily. All data is updated once a day. To get Intraday updates, upgrade your subscription in the Account > Manage Subscriptions."
              "Your update period is set to Daily. Prices and range signals are updated every hour throughout the day. All other data is updated once a day at the close."
        }
        className="info-icon"
        style={{
          fontWeight: "bold",
          color: "white",
          borderColor: "white",
          marginLeft: 5,
          marginBottom: 3,
        }}
      >
        i
      </div>
    </>
  );
}

export default LastUpdated;
